import { _request, APIBaseResponse,APIMethod } from '../index';
import { RequestParamsBase } from '../Models/CommonRequestModels';

const TENANTS_PATH_PREFIX = '/tenants';
const PRODUCT_PACKAGES_PATH_PREFIX = 'packages';

type APIProductPackagesListParams = RequestParamsBase & {
    tenantId: string;
};

type APIProductPackagesListResponse = APIBaseResponse<
    Array<{
        tenantId: string;
        productPackageId: string;
        packageName: string;
        packageNote: string;
    }>
>;

export type APIProductPackagePostParams = RequestParamsBase & {
    tenantId: string;
    packageName: string;
    packageNote?: string;
};

export type APIProductPackagePostResponse = APIBaseResponse<{
    tenantId: string;
    productPackageId: string;
    packageName: string;
    packageNote: string;
}>;

export type APIProductPackagePutParams = RequestParamsBase & {
    tenantId: string;
    productPackageId: string;
    packageName: string;
    packageNote?: string;
};

export type APIProductPackagePutResponse = APIBaseResponse<{
    tenantId: string;
    productPackageId: string;
    packageName: string;
    packageNote: string;
}>;

type APIProductPackageGetSingleParams = RequestParamsBase & {
    tenantId: string;
    productPackageId: string;
};

export type APIProductPackageGetSingleResponse = APIBaseResponse<{
    tenantId: string;
    productPackageId: string;
    packageName: string;
    packageNote: string;
}>;

export type APIProductPackageDeleteParams = RequestParamsBase & {
    tenantId: string;
    productPackageId: string;
};

export const APIProductPackagesGetList: APIMethod<APIProductPackagesListParams, APIProductPackagesListResponse> = (params: APIProductPackagesListParams) => (
    _request('GET', `${TENANTS_PATH_PREFIX}/${params.tenantId}/${PRODUCT_PACKAGES_PATH_PREFIX}`, undefined, params.signal)
);

export const APIProductPackagePost: APIMethod<APIProductPackagePostParams, APIProductPackagePostResponse> = (params: APIProductPackagePostParams) => (
    _request('POST', `${TENANTS_PATH_PREFIX}/${params.tenantId}/${PRODUCT_PACKAGES_PATH_PREFIX}`, {
        tenantId: params.tenantId,
        packageName: params.packageName,
        packageNote: params.packageNote || ''
    }, params.signal)
);

export const APIProductPackageGetSingle: APIMethod<APIProductPackageGetSingleParams, APIProductPackageGetSingleResponse> = (params: APIProductPackageGetSingleParams) => (
    _request('GET', `${TENANTS_PATH_PREFIX}/${params.tenantId}/${PRODUCT_PACKAGES_PATH_PREFIX}/${params.productPackageId}`, undefined, params.signal)
);

export const APIProductPackagePut: APIMethod<APIProductPackagePutParams, APIProductPackagePutResponse> = (params: APIProductPackagePutParams) => (
    _request('PUT', `${TENANTS_PATH_PREFIX}/${params.tenantId}/${PRODUCT_PACKAGES_PATH_PREFIX}/${params.productPackageId}`, {
        tenantId: params.tenantId,
        productPackageId: params.productPackageId,
        packageName: params.packageName,
        packageNote: params.packageNote || ''
    }, params.signal)
);

export const APIProductPackageDelete: APIMethod<APIProductPackageDeleteParams, APIBaseResponse> = (params: APIProductPackageDeleteParams) => (
    _request('DELETE', `${TENANTS_PATH_PREFIX}/${params.tenantId}/${PRODUCT_PACKAGES_PATH_PREFIX}/${params.productPackageId}`, undefined, params.signal)
);